import { fetchOpts } from './fetchUtil';

export class FetchError extends Error {
  constructor(
    message: string,
    public status: number,
    public response?: unknown
  ) {
    super(message);
    this.name = 'FetchError';
  }
}

type FetchConfig = {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  body?: unknown;
  contentType?: string;
  responseType?: 'json' | 'blob' | 'text';
};

export const authFetch = async <T>(
  url: string,
  token: string,
  config: FetchConfig = {}
): Promise<T> => {
  const { method = 'GET', body, contentType = 'application/json', responseType = 'json' } = config;

  const headers: HeadersInit = {
    'Content-Type': contentType,
    Authorization: `Bearer ${token}`
  };

  const response = await fetch(url, {
    ...fetchOpts(method),
    headers,
    body: body ? (body instanceof URLSearchParams ? body : JSON.stringify(body)) : undefined
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => null);
    throw new FetchError(
      `Request failed with status ${response.status}`,
      response.status,
      errorBody
    );
  }

  if (responseType === 'blob') {
    return response.blob() as Promise<T>;
  }

  if (responseType === 'text') {
    return response.text() as Promise<T>;
  }

  const data = await response.json();

  if (data.errors && data.errors[0]) {
    throw new FetchError('API returned errors', response.status, data.errors);
  }

  return data as T;
};
